import { Box, Button, Typography } from '@mui/material';
import { Token } from '@uniswap/sdk-core';
import { CommonModal, ExternalLink, TokenAvatarPair } from 'common-client';
import React from 'react';

export interface CreateAuctionRebaseWarningModalProps {
  /**
   * Callback when dismissing the modal
   */
  onExit?: () => void;
  /**
   * Callback when pressing the modal button
   */
  onAccept?: () => void;
  /**
   * Whether the modal is open
   */
  open: boolean;
}

const leftToken = new Token(1, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 0, 'AMPL', 'Ampleforth');
const rightToken = new Token(1, '0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5', 0, 'OHM', 'Olympus');

export function CreateAuctionRebaseWarningModal({
  onExit,
  onAccept,
  open,
}: CreateAuctionRebaseWarningModalProps) {
  return (
    <CommonModal
      open={open}
      onExit={onExit}
      maxWidth="xs"
      fullWidth
      testId="create-auction-rebase-warning-modal"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <TokenAvatarPair
          leftToken={leftToken}
          rightToken={rightToken}
          sx={{ width: '32px', height: '32px' }}
        />
      </Box>
      <Typography
        align="center"
        fontSize="24px"
        fontWeight={700}
        mt="16px"
      >
        Note on Rebasing Assets
      </Typography>
      <Typography
        variant="body2"
        lineHeight="24px"
        align="center"
        mt="8px"
      >
        Auctions have not been designed to support rebasing assets.
        We strongly recommend against creating auctions with a rebasing asset.
      </Typography>
      <Typography
        variant="body2"
        lineHeight="24px"
        align="center"
        mt="8px"
      >
        For more information, please refer to our
        {' '}
        <ExternalLink
          href="https://docs.prl.one/buttonwood/user-guides/buttonauctions-user-guide/note-on-rebasing-assets"
          text="documentation"
          hideIcon
        />
        .
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt="16px"
      >
        <Button
          color="secondary"
          variant="contained"
          onClick={onAccept}
          style={{
            borderRadius: '24px', width: '100%', fontSize: '14px', padding: '12px',
          }}
        >
          {'Okay, don\'t show this again'}
        </Button>
      </Box>
    </CommonModal>
  );
}
